import { COUNTRIES, Country } from '@/constants/countries-phones';

export const findCountryByIso2 = (iso2: string | null | undefined): Country | undefined => {
  if (!iso2) return undefined;
  const normalized = iso2.toLowerCase();
  return COUNTRIES.find((c) => c.iso2 === normalized);
};
